import styled from 'styled-components';

export const StyledGeneralWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  & > div:first-of-type > div:nth-of-type(2) > h4:first-of-type {
    margin-bottom: ${({ theme }): string => theme.spacing_unit_x1};
  }

  & > div:first-of-type > div:nth-of-type(2) > h4:nth-of-type(2) {
    margin-top: ${({ theme }): string => theme.spacing_unit_x1};
  }

  & > div:first-of-type > div:nth-of-type(2) > h4:last-of-type {
    margin-top: ${({ theme }): string => theme.spacing_unit_x4};
    margin-bottom: ${({ theme }): string => theme.spacing_unit_x2};
  }
`;
